import { render, staticRenderFns } from "./NewMonthlyPaymentRecived.vue?vue&type=template&id=6231ff7d"
import script from "./NewMonthlyPaymentRecived.vue?vue&type=script&lang=js"
export * from "./NewMonthlyPaymentRecived.vue?vue&type=script&lang=js"
import style0 from "./NewMonthlyPaymentRecived.vue?vue&type=style&index=0&id=6231ff7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports